// Типы и константы для обращений клиентов

export const TICKET_STATUS = {
  OPEN: "open",
  WAITING: "waiting",
  RESOLVED: "resolved",
  CLOSED: "closed",
} as const;

export const TICKET_PRIORITY = {
  HIGH: "high",
  NORMAL: "normal",
  LOW: "low",
} as const;

export type TicketStatus = (typeof TICKET_STATUS)[keyof typeof TICKET_STATUS];
export type TicketPriority = (typeof TICKET_PRIORITY)[keyof typeof TICKET_PRIORITY];

export interface ITicketFile {
  id: number;
  uuid: string;
  ticket_id: number;
  file_name: string;
  file_url: string;
  file_size?: number;
  mime_type?: string;
  created_at: string;
}

export interface ITicket {
  id: number;
  uuid: string;
  account_id: number;
  title: string;
  description: string;
  status: string;
  priority: string;
  section?: string;
  is_read_by_author: boolean;
  is_read_by_support: boolean;
  is_blocked: boolean;
  block_reason?: string;
  blocked_at?: string;
  blocked_by?: number;
  delete_reason?: string;
  deleted_by?: number;
  messages_count?: number;
  files?: ITicketFile[];
  last_activity_at: string;
  closed_at?: string;
  created_at: string;
  updated_at?: string;
  deleted_at?: string;
  // Данные автора, обогащённые на бэкенде
  author_login?: string;
  author_email?: string;
}

export interface ITicketMessage {
  id: number;
  uuid: string;
  ticket_id: number;
  message: string;
  account_id?: number;
  support_id?: number;
  is_from_customer: boolean;
  is_blocked: boolean;
  block_reason?: string;
  delete_reason?: string;
  created_at: string;
  updated_at?: string;
  deleted_at?: string;
}

export interface ITicketStats {
  total: number;
  open: number;
  waiting: number;
  resolved: number;
  closed: number;
  high_priority: number;
  today: number;
  this_week: number;
  this_month: number;
  unread_count: number;
}

export interface ITicketFilter {
  q?: string;
  status?: string;
  priority?: string;
  show_deleted?: boolean;
  page?: number;
  limit?: number;
}

export const TICKET_SECTIONS = [
  { key: "REGISTRATION_LOGIN", label: "Регистрация и вход" },
  { key: "ACCOUNT_SETTINGS", label: "Настройки аккаунта" },
  { key: "WB_CONNECTION", label: "Подключение Wildberries" },
  { key: "OZON_CONNECTION", label: "Подключение Ozon" },
  { key: "DATA_SYNC", label: "Синхронизация данных" },
  { key: "REPORTS_STATS", label: "Отчёты и статистика" },
  { key: "DATA_DISCREPANCY", label: "Расхождение данных" },
  { key: "PAYMENT_PLANS", label: "Оплата и тарифы" },
  { key: "REFUND", label: "Возврат средств" },
  { key: "REFERRAL", label: "Реферальная программа" },
  { key: "FEATURE_REQUEST", label: "Предложение по улучшению" },
  { key: "OTHER", label: "Другое" },
] as const;

export function getStatusText(status: string): string {
  const map: Record<string, string> = {
    open: "Открыт",
    waiting: "Ожидание",
    resolved: "Решён",
    closed: "Закрыт",
  };
  return map[status] || status;
}

export function getPriorityText(priority: string): string {
  const map: Record<string, string> = {
    high: "Высокий",
    normal: "Средний",
    low: "Низкий",
  };
  return map[priority] || priority;
}

export function getSectionLabel(section?: string): string {
  if (!section) return "—";
  const found = TICKET_SECTIONS.find((s) => s.key === section);
  return found ? found.label : section;
}
